import parse from "html-react-parser";

export default function DynamicBooleanField({field, value, onFieldChange, error, instanceId}) {
    const hasError = Boolean(error);
    const inputName = `${field.code}-${instanceId}`;

    return <div className="">

        <label className="text-x font-medium" >
            {field.name}
            {field.required && <span className="text-red-600 ml-1">*</span>}
        </label>

        {field.help && (
            <div className="text-sm text-gray-500 mt-1 mb-2">
                {parse(field.help)}
            </div>
        )}

        <div
            className={`
                    flex items-center gap-6 w-full h-10 px-3 py-2 rounded-lg border transition-all
                    ${hasError
                ? "border-red-500 bg-red-50"
                : "border-white focus-within:ring-2 focus-within:ring-[#2f855a]"
            }
                `}
        >

            <label className="flex items-center gap-2 cursor-pointer">
                <input
                    id={`${inputName}-yes`}
                    type="radio"
                    name={inputName}
                    value="Yes"
                    checked={value === "Yes"}
                    onChange={onFieldChange}
                    className={`accent-[#1C3353] ${hasError ? "ring-red-500" : ""}`}
                />
                Yes
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
                <input
                    id={`${inputName}-no`}
                    type="radio"
                    name={inputName}
                    value="No"
                    checked={value === "No"}
                    onChange={onFieldChange}
                    className={`accent-[#1C3353] ${hasError ? "ring-red-500" : ""}`}
                />
                No
            </label>

        </div>
        {error && (
            <div className="text-red-600 text-sm mt-1">
                {error}
            </div>
        )}

    </div>

}